export default "__VITE_ASSET__75172a98__"